import React from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { Formik, Form, } from "formik";
import * as Yup from "yup";

//  Yup validation schema
const validationSchema = Yup.object().shape({
  addressLine1: Yup.string().required("Address Line 1 is required"),
  addressLine2: Yup.string().required("Address Line 2 is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  postal_code: Yup.string()
    .matches(/^[0-9]{4,6}$/, "Invalid postal code")
    .required("Postal Code is required"),
  region: Yup.string().required("Country is required"),
});

const EditAddressModal = ({
  open,
  onClose,
  addressData = {},
  onSave,
  saving,
}) => {
  const initialValues = {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postal_code: "",
    region: "",
    type: "",
    isDefault: false,
    latitude: null,
    longitude: null,
    ...addressData, // prefill if data exists
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>Edit Address</DialogTitle>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSave(values);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur }) => (
          <Form>
            <DialogContent>
              <Box display="flex" flexDirection="column" gap={2} mt={1}>
                <TextField
                  fullWidth
                  label="Address Line 1"
                  name="addressLine1"
                  value={values.addressLine1}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.addressLine1 && Boolean(errors.addressLine1)}
                  helperText={touched.addressLine1 && errors.addressLine1}
                />
                <TextField
                  fullWidth
                  label="Address Line 2"
                  name="addressLine2"
                  value={values.addressLine2}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.addressLine2 && Boolean(errors.addressLine2)}
                  helperText={touched.addressLine2 && errors.addressLine2}
                />
                <TextField
                  fullWidth
                  label="City"
                  name="city"
                  value={values.city}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.city && Boolean(errors.city)}
                  helperText={touched.city && errors.city}
                />
                <TextField
                  fullWidth
                  label="State"
                  name="state"
                  value={values.state}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.state && Boolean(errors.state)}
                  helperText={touched.state && errors.state}
                />
                <TextField
                  fullWidth
                  label="Postal Code"
                  name="postal_code"
                  value={values.postal_code}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.postal_code && Boolean(errors.postal_code)}
                  helperText={touched.postal_code && errors.postal_code}
                />
                <TextField
                  fullWidth
                  label="Country"
                  name="region"
                  value={values.region}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.region && Boolean(errors.region)}
                  helperText={touched.region && errors.region}
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      name="isDefault"
                      checked={values.isDefault}
                      onChange={handleChange}
                      sx={{
                        color: "#FBC02D",
                        "&.Mui-checked": { color: "#FBC02D" },
                      }}
                    />
                  }
                  label="Set as default address"
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={onClose}
                variant="outlined"
                sx={{
                  px: 4,
                  height: 40,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 500,
                }}
                disabled={saving}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  bgcolor: "#FBC02D",
                  "&:hover": { bgcolor: "#F9A825" },
                  px: 4,
                  height: 40,
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 500,
                }}
                disabled={saving}
              >
                {saving ? "Saving..." : "Save"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditAddressModal;
